import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import isEmpty from 'lodash/isEmpty'

// State
import { submitENewsSignup } from '../../store/actions/enews'

// CSS
import './../../css/enews-form.css'

class ENewsForm extends Component {
	constructor(props){
		super(props)
		this.state = {
			email: ''
		}
	}

	handleKeyPress(event) {
		if (event.key === 'Enter') {
			event.preventDefault()
			this.handleSubmit()
		}
	}

	handleInputChange(event) {
		const { name, value } = event.target
		this.setState({
			[name]: value
		})
	}

	handleSubmit(){
		this.props.submitENewsSignup(this.state.email)
	}

	render(){
		return (
			<Fragment>
				{!isEmpty(this.props.errors) &&
					<div className="error">
						{Object.keys(this.props.errors).map(key => {
							return <div key={key}>{this.props.errors[key]}</div>
						})}
					</div>
				}
				{this.props.success ? (
					<div className="success">
						Thank you for joining our enewsletter!
					</div>
				) : (
					<div className="enews_form">
						<input type="email" name="email" placeholder="Subscribe to our E-Newsletter" value={this.state.email}
							onKeyPress={e => this.handleKeyPress(e)}
							onChange={e => this.handleInputChange(e)}
						/>
						<button className={'btn' + (this.props.isLoading ? ' loading' : '')} onClick={() => this.handleSubmit()}>
							<span>Join!</span>
						</button>
					</div>
				)}
			</Fragment>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		isLoading: state.enews.isLoading,
		errors: state.enews.errors,
		success: state.enews.success
	}
}

export default connect(mapStateToProps, { submitENewsSignup })(ENewsForm)



// WEBPACK FOOTER //
// ./src/components/footer/ENewsForm.js